import React, { ReactNode } from "react";
import { useNavigate } from "react-router-dom";

export function BackButton(){
    const navigate = useNavigate()

    return <button className="btn btn-primary me-3" style={{borderRadius: '50%', width: '40px', height: '40px'}} onClick={() => navigate(-1)}>
        <i className="fa fa-arrow-left"></i>
    </button>
}

export function BackButtonBar({children}:{children:ReactNode}){
    return <div className="d-flex align-items-center mb-3">
        <BackButton />
        {children}
    </div>
}